export default "__VITE_ASSET__BgAzXMFe__"